import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

export function ChangelogUpsell() {
    return (
        <EmptyStateSmall
            icon={<Illustration src='padlock-lady' width={60} />}
            title='Your plan doesn’t have access to the changelog'
            subtitle={
                <Link
                    variant='primary'
                    size='big'
                    // @ts-expect-error
                    as={RoutedLink}
                    to='/setup/billing/sales'
                    newTab={true}
                >
                    Upgrade to learn more
                </Link>
            }
        />
    );
}
